import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { changePassword } from '../api/auth.api';
import { authQueryKeys } from '../api/auth.api';

export function useChangePassword(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { oldPassword: string; newPassword: string }) => changePassword(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: authQueryKeys.profile() });
      toast.success('Password changed successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to change password');
    },
  });
}
